module.exports = __webpack_public_path__ + "static/media/bryce_shadow.33509a45.jpeg";